export enum InstituteStatus {
    DRAFT,
	ACTIVE,
	DELETED,
	ALL
}

export const INSTITUTE_STATUS = ["DRAFT", "ACTIVE", "DELETED", "ALL"];